import React from "react";
import { COPY } from "@/data/waitlistOptions";
import { LANDING } from "@/constants/testIds/waitlist";

export const MissionSection = () => (
  <section
    data-testid={LANDING.missionSection}
    aria-labelledby="mission-heading"
    className="border-t border-white/10"
  >
    <div className="mx-auto max-w-4xl px-6 sm:px-8 py-24 sm:py-28 text-center">
      <p
        id="mission-heading"
        className="font-condensed uppercase tracking-[0.42em] text-[#D9B872] text-sm"
      >
        {COPY.missionKicker}
      </p>
      <p className="mt-6 mx-auto max-w-3xl text-white/85 text-xl sm:text-2xl leading-relaxed font-light">
        {COPY.mission}
      </p>
    </div>
  </section>
);
